import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const QuickActionFloat = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const quickActions = [
    {
      id: 'mood',
      label: 'Log Mood',
      path: '/mood-tracker',
      icon: 'Heart',
      color: 'accent'
    },
    {
      id: 'schedule',
      label: 'Schedule',
      path: '/intimacy-scheduler',
      icon: 'Calendar',
      color: 'primary'
    }
  ];

  const shouldShowQuickAction = () => {
    const excludedPaths = ['/mood-tracker', '/intimacy-scheduler'];
    return !excludedPaths?.includes(location?.pathname);
  };

  const handleActionClick = (path) => {
    navigate(path);
    setIsOpen(false);
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  if (!shouldShowQuickAction()) return null;

  return (
    <>
      <div className="fixed bottom-20 right-4 z-notification lg:bottom-6 lg:right-6">
        <div className="relative">
          {isOpen && (
            <div className="absolute bottom-16 right-0 flex flex-col space-y-3 mb-2">
              {quickActions?.map((action) => (
                <button
                  key={action?.id}
                  onClick={() => handleActionClick(action?.path)}
                  className={`
                    flex items-center space-x-3 px-4 py-3 rounded-md
                    bg-card text-foreground border border-border
                    shadow-therapeutic transition-therapeutic
                    hover:shadow-therapeutic-lg hover:scale-105
                  `}
                >
                  <Icon 
                    name={action?.icon} 
                    size={20} 
                    color={`var(--color-${action?.color})`}
                  />
                  <span className="text-sm font-medium font-caption whitespace-nowrap">
                    {action?.label}
                  </span>
                </button>
              ))}
            </div>
          )}

          <button
            onClick={toggleMenu}
            className={`
              flex items-center justify-center w-14 h-14 rounded-full
              shadow-therapeutic-lg transition-therapeutic
              ${isOpen
                ? 'bg-muted text-foreground rotate-45'
                : 'bg-primary text-primary-foreground hover:scale-105'
              }
            `}
            aria-label={isOpen ? 'Close quick actions' : 'Open quick actions'}
          >
            <Icon 
              name="Plus" 
              size={24} 
              color="currentColor"
            />
          </button>
        </div>
      </div>
      {isOpen && (
        <div
          className="fixed inset-0 z-[99] bg-background lg:hidden"
          onClick={() => setIsOpen(false)}
        />
      )}
    </>
  );
};

export default QuickActionFloat;